import { actions } from './actions';
import { listenForMessage } from './listenToMessage';

export const nativeApp = {
  ...actions,
  listenForMessage,
  settings: typeof window !== 'undefined' ? window.mobileSettings : undefined,
};

export * from './utils';

export type { Actions, NativeAppAction, NativeUniclientAction } from './actions';
export { isNativeAndroid } from './android';
export { isNativeIOS, WEBKIT_MESSAGE_HANDLER_NAME } from './ios';
export type { MobileSettings } from './mobileSettings';
export { NativePresentationMode } from './mobileSettings';
export { LimeProductLine } from './actions/redirectToHome';
export type { RedirectToHomeAction, RedirectToHomeProps } from './actions/redirectToHome';
export type { IncomingMessage } from './listenToMessage';
export type { NativeUrlActionProps } from './actions/openUrl';
export type { OpenPhotoCollectionProps } from './actions/openPhotoCollection';
export type { MediaData, MediaType } from './shared/media.types';
export type { PhotoCollectionData } from './incoming/photoCollection';
export type { RetryPhotoCollectionProps } from './actions/retryPhotoCollection';
export { invokeAction } from './actions/invoke';
